import { FC, useEffect } from "react";
import F7 from "../../../utils/F7";

const Spinner: FC<{ title?: string; timeout?: number }> = ({ title, timeout }) => {
  useEffect(() => {
    let timeoutTimer: undefined | NodeJS.Timeout;
    const showDelay = 0;
    const showTimer = setTimeout(() => F7.showIndicator(), showDelay);
    if (timeout) {
      timeoutTimer = setTimeout(() => F7.hideIndicator(), timeout);
    }
    return function cleanup() {
      clearTimeout(showTimer);
      clearTimeout(timeoutTimer);
      F7.hideIndicator();
    };
  }, [timeout]);

  return title ? (
    <span
      style={{
        position: "absolute",
        width: "200px",
        left: "calc(50% - 100px)",
        top: "calc(50vh + 30px)",
        padding: "10px",
        textAlign: "center",
      }}
    >
      {title}
    </span>
  ) : null;
};

export default Spinner;
